module.exports = __webpack_public_path__ + "static/media/ludocasino.3dfccb3d.png";